// extracted by mini-css-extract-plugin
module.exports = {"photoOverlay":"PhotoOverlay_photoOverlay__10paQ","img":"PhotoOverlay_img__gG5Zz"};